import React from 'react';
import Register from '../../components/register';

const RegisterContainer = () => <Register />;

export default RegisterContainer;
